
import { createSlice } from "@reduxjs/toolkit";

import { fetchCompanyListData } from "../thunks/companyThunk";

interface OnBoardServiceVendor {
  company_id: string;
  email?: string; // Optional, in case some vendors don’t have emails
  name: string;
  phone?: string; // Optional, in case phone numbers are missing
  type: string;
}

interface FetchApiResponce {
  charterer: OnBoardServiceVendor[];
  delivery_vendor_vendors: OnBoardServiceVendor[];
  bunkers_freshwater_suppliers: OnBoardServiceVendor[];
  surveyor: OnBoardServiceVendor[];
  on_board_service_vendors: OnBoardServiceVendor[];
  job_id:string
} 
interface CompanyListState {
  company: FetchApiResponce | null;
  loading: boolean;
  error: string | null;
}

const initialState: CompanyListState = {
  company: null,
  loading: false,
  error: null,
};

export const phoneListSlice = createSlice({
  name: "company",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCompanyListData.pending, (state) => { 
        state.loading = true;
      })
      .addCase(fetchCompanyListData.fulfilled, (state, action) => {
        state.company = action.payload;
        state.loading = false;
      })
      .addCase(fetchCompanyListData.rejected, (state, action) => { 
        state.error = action.payload as string;
        state.loading = false;
      });
  },
});

export default phoneListSlice.reducer;
